export default "__VITE_ASSET__8GUushuR__"